<template>
  <router-view />
</template>

<script setup lang="ts">
import { useMenuStore } from './layouts/menu/menu.store';
import { onMounted } from 'vue';

const menu = useMenuStore();

onMounted(() => {
  menu.setMenu('admin');
});
</script>
